import { createAction, props } from '@ngrx/store';

export const executePageBehaviourRequest = createAction('[BasicPage] Execute Page Behaviour Request', props<{ pageId: string, clientId: string, actionId: string, assetId: string }>());
export const executePageBehaviourDone = createAction('[BasicPage] Execute Page Behaviour Done');
